<div id="widgetHeight" class="widget_section" style="height:614px;">
  <widget-ui id="widget3" request_code="" widget_mode="LIVE"></widget-ui>
  <div class="text-center"></div>
</div>
<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false" color="primary">close</button>
</div> 
